'use client'

import {
  DeadpoolV2OperationalModel,
  OperationalModel,
  OperationalModelContextProviderProps,
} from '~types/index'

import React, { FC, useState } from 'react'

import { setCookieCSR } from '@/app/api/CSR/Cookies'
import { DEFAULT_COOKIE_STORE_DAYS } from '@/utils/constants'
import { selectedMutations } from '@mercadoni/sinister/dist/cjs/shared/services'

interface updateOperationalModelProps {
  (operationalModel: DeadpoolV2OperationalModel): void
}

export const OperationalModelContext = React.createContext<{
  operationalModel: OperationalModel
  updateOperationalModel: updateOperationalModelProps
}>({ operationalModel: {}, updateOperationalModel: console.log })

export const useOperationalModelContext = () =>
  React.useContext(OperationalModelContext)

export const OperationalModelContextProvider: FC<
  OperationalModelContextProviderProps
> = ({ children, operationalModel: operationalModelSSR }) => {
  const [operationalModel, setOperationalModel] =
    useState<OperationalModel>(operationalModelSSR)

  const updateOperationalModel: updateOperationalModelProps = (
    opsModel: DeadpoolV2OperationalModel
  ) => {
    const newOperationalModel = { opsModel }
    setOperationalModel(newOperationalModel)
    setCookieCSR(
      '_IL-selectedOpsModel',
      JSON.stringify(newOperationalModel),
      DEFAULT_COOKIE_STORE_DAYS
    )
    if (typeof window !== 'undefined') {
      window?.localStorage?.setItem(
        'selectedOpsModel',
        JSON.stringify(newOperationalModel)
      )
    }
    selectedMutations.updateOpsModel(newOperationalModel)
  }

  return (
    <OperationalModelContext.Provider
      value={{ operationalModel, updateOperationalModel }}
    >
      {children}
    </OperationalModelContext.Provider>
  )
}
